module.exports = __webpack_public_path__ + "img/2.43e84b88.png";